import { ReduxSimpleActionInterface } from '@ecommerce/nest-ssr/dist/common';
import WidgetArticleProps from 'modules/shared/widgets/components/widget-articles/widget-article.props';

export enum ArticlesActions {
    AddNativeArticle = 'ADD_NATIVE_ARTICLE'
}

interface NativeArticleInterface {
    id: string;
    article: WidgetArticleProps | null;
}

export interface ArticlesState {
    nativeArticles: NativeArticleInterface[];
}

export const articles = [
    (
        state: ArticlesState,
        action: ReduxSimpleActionInterface<ArticlesActions, { payload: NativeArticleInterface; }>
    ): ArticlesState => {
        switch (action.type) {
            case ArticlesActions.AddNativeArticle: {
                const articleIndex = state?.nativeArticles?.findIndex(item => item.id === action.payload.id);

                if (articleIndex > -1) {
                    return {
                        ...state,
                        nativeArticles: state.nativeArticles.map((item, index) => articleIndex === index ? action.payload : item)
                    };
                }

                return { ...state, nativeArticles: !state?.nativeArticles ? [action.payload] : [...state.nativeArticles, action.payload] };
            }
            default:
                return state;
        }
    }
];
